import type { PersonaType } from '../../../../service';
import { DistributionListMember, PersonType } from '../../../../shared';

export function createPrivateDistributionListOrMember(
    personaType: PersonaType
): DistributionListMember {
    return {
        type: PersonType.PrivateDistributionListMember,
        displayName: personaType.DisplayName,
        emailAddressWrapper: personaType.EmailAddress,
        isPdl: personaType.EmailAddress.MailboxType === 'PrivateDL',
        isManuallyTypedEmail: false,
    };
}
